"use client";

import { Check } from "lucide-react";
import { useLocale, useTranslations } from "next-intl";

export interface RegistrationFlowAutoSaveNoteProps {
    lastSaved: Date | null;
}

export function RegistrationFlowAutoSaveNote({
    lastSaved,
}: RegistrationFlowAutoSaveNoteProps) {
    const locale = useLocale();
    const t = useTranslations("strings.registrationFlow");

    return (
        <div className="mt-8 rounded-xl border border-fest-border-warm bg-white p-4">
            <div className="flex items-start gap-3">
                <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-fest-apple-green/10">
                    <Check className="h-5 w-5 text-fest-apple-green" />
                </div>
                <div className="min-w-0 space-y-2">
                    <h4 className="text-sm font-bold text-fest-heading">
                        {t("autoSaveTitle")}
                    </h4>
                    <p className="text-xs leading-relaxed text-fest-subtle-text">
                        {t("autoSaveDescription")}
                    </p>
                    {lastSaved ? (
                        <p className="text-xs font-medium text-fest-apple-green">
                            {t("lastSavedPrefix")}{" "}
                            {lastSaved.toLocaleTimeString(
                                locale === "az"
                                    ? "az-AZ"
                                    : locale === "ru"
                                      ? "ru-RU"
                                      : "en-US",
                                {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    second: "2-digit",
                                },
                            )}
                        </p>
                    ) : null}
                </div>
            </div>
        </div>
    );
}
